(function () {
    'use strict';

    angular
        .module('app.accessibility', [
            'app.core',
            'utils'
        ]);
})();